import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";

type DialogProps = {
  open: boolean;
  children: React.JSX.Element;
  handleClose: () => void;
  title?: string;
  hasConfirmation?: boolean;
  handleConfirm?: () => void;
  confirmationText?: string;
};

export default function CustomDialog({
  open,
  children,
  title,
  handleClose,
  hasConfirmation = false,
  handleConfirm,
  confirmationText,
}: DialogProps) {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      data-testid="custom-dialog"
    >
      {title && <DialogTitle id="alert-dialog-title">{title}</DialogTitle>}
      <DialogContent sx={{ paddingTop: "0.5rem !important" }}>
        {children}
      </DialogContent>
      <DialogActions>
        <Button
          variant={"outlined"}
          onClick={handleClose}
          data-testid="dialog-cancel"
        >
          Cancel
        </Button>
        {hasConfirmation && (
          <Button
            variant={"contained"}
            onClick={handleConfirm}
            data-testid="dialog-confirm"
          >
            {confirmationText ? confirmationText : "Confirm"}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
